import * as yup from "yup";

export const CONTACT_REPRESENTATIVE_EDIT_FORM_SCHEMA = yup.object().shape({
  personContactId: yup.string().required("Molimo Vas da odaberete osobu"),
});
